import {useInvalidateOnAliveUpdate} from '@github-ui/use-invalidate-on-alive-update'
import {useAssigneesQueryKey} from '../components/overview/data/route-queries'
import type {AliveChannels} from '../page-data/payloads/header'
import type {PullRequestAliveData} from './use-refetch-on-alive-update'

const filter = (data: PullRequestAliveData) => Boolean(data.event_updates?.assignees_updated)
const emptyQueryKey = [] as const

export function useAssigneesLiveUpdates(aliveChannels: AliveChannels | undefined): void {
  const queryKey = useAssigneesQueryKey()

  useInvalidateOnAliveUpdate(queryKey ? (aliveChannels?.pullRequest ?? '') : '', queryKey ?? emptyQueryKey, {
    filter,
  })
}
